import { t } from "@/i18n-js/instance";
import { FormTipTapBlockEditor } from "@circle-react-uikit/Form/FormTipTapBlockEditor/FormTipTapBlockEditor";

const DISABLED_EXTENSIONS = [
  "blockquote",
  "poll",
  "embeds",
  "slash_commands",
  "file",
  "image",
  "horizontal_rule",
  "code_block",
  "headings",
  "cta",
  "mention",
  "entities",
];

export const DescriptionEditor = () => (
  <FormTipTapBlockEditor
    placeholder={t("courses.edit.lesson.quiz_description_placeholder")}
    name="quiz[description][body]"
    disabledExtensions={DISABLED_EXTENSIONS}
    shouldShowTextModifiersMenu={false}
    editorClassName="!scale-100"
  />
);
